export default __webpack_public_path__ + "static/media/3334 cutlery top.92842f7e.png";